// extracted by mini-css-extract-plugin
export default {"viewTemplatesContainer":"ViewMedicationTemplate_viewTemplatesContainer__DccOa"};